module.exports = __webpack_public_path__ + "img/15_42.d8de9a86.png";